import { CiLocationOn, CiMail } from "react-icons/ci";
import Subscribe from "Components/SubscribeNewsletter/SubscribeNewsletter";

const ContactUsLinks = () => {
  return (
    <div className="footer-section contact-links">
      <p className="footer-heading">Contact Us</p>
      <p className="contact-meta-row">
        <span className="contact-link-icon">
          <CiLocationOn />
        </span>
        <span>124 City Road, London, EC1V 2NX</span>
      </p>
      <a href="mailto:info@kewordal.com" className="contact-link">
        <span className="contact-link-icon">
          <CiMail />
        </span>
        <span>info@kewordal.com</span>
      </a>
      <div className="footer-newsletter-input">
        <Subscribe isFooter />
      </div>
    </div>
  );
};

export default ContactUsLinks;
